export default {
  hideMobileBottomNavigation(context) {
    context.commit('HIDE_MOBILE_BOTTOM_NAVIGATION');
  },
  showMobileBottomNavigation(context) {
    context.commit('SHOW_MOBILE_BOTTOM_NAVIGATION');
  },
};
